<template>
  <div>
    <div class="gdlr-core-pbf-wrapper" style="margin-top: 60px; padding: 15px 0px 0px 0px;"
         id="gdlr-core-wrapper-2">
      <div class="gdlr-core-pbf-background-wrap">
        <div class="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js"
             style="background-image: url(static/upload/about-2-about-bg.png); background-repeat: no-repeat; background-position: top center;"
             data-parallax-speed="0"></div>
      </div>
      <div class="gdlr-core-pbf-wrapper-content gdlr-core-js">
        <div class="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
          <div class="gdlr-core-pbf-column gdlr-core-column-30 gdlr-core-column-first gdlr-core-hide-in-mobile"
               id="gdlr-core-column-38316">
            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js" style="padding: 50px 40px 0px 0px;">
              <div class="gdlr-core-pbf-background-wrap">
                <div class="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js"
                     style="background-size: cover; background-position: center;" data-parallax-speed="0"></div>
              </div>
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-image-item gdlr-core-item-pdb gdlr-core-center-align gdlr-core-item-pdlr"
                       style="padding-bottom: 50px;">
                    <div
                      class="gdlr-core-image-item-wrap gdlr-core-media-image gdlr-core-image-item-style-rectangle"
                      style="border-width: 0px; margin-right: 10px;">
                      <img src="static/upload/img-001.jpg" alt="" width="900" height="623" title="img 001">
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-divider-item gdlr-core-divider-item-normal gdlr-core-item-pdlr gdlr-core-right-align gdlr-core-style-vertical"
                    style="margin-bottom: 0px;">
                    <div class="gdlr-core-divider-line gdlr-core-skin-divider"
                         style="border-color: #d32525; height: 90px;"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="gdlr-core-pbf-column gdlr-core-column-30" id="gdlr-core-column-7419">
            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js"
                 style="margin: 0px 0px 110px; padding: 70px 0px 0px 50px; height: 524.68px;"
                 data-sync-height="height-img">
              <div class="gdlr-core-pbf-background-wrap"></div>
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js gdlr-core-sync-height-content">
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr"
                    style="padding-bottom: 40px;">
                        <span
                          class="gdlr-core-title-item-caption gdlr-core-info-font gdlr-core-skin-caption"
                          style="font-size: 14px; font-weight: 500; font-style: normal; letter-spacing: 3px; text-transform: uppercase; color: #d32525;">
                          <span class="gdlr-core-title-item-left-dot"
                                style="width: 5px; height: 5px; background-color: #d32525; margin-right: 15px;"></span>
                          Advantage
                          </span>
                    <div class="gdlr-core-title-item-title-wrap">
                      <h3 class="gdlr-core-title-item-title gdlr-core-skin-title"
                          style="font-size: 44px; font-weight: 500; letter-spacing: 0px; text-transform: none; color: #353535;">
                        家族信托的优势
                        <span class="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                      </h3>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-icon-list-item gdlr-core-item-pdlr gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-style-1"
                    style="padding-bottom: 5px;">
                    <ul>
                      <li class="gdlr-core-skin-divider clearfix" style="margin-bottom: 17px;">
                        <span class="gdlr-core-icon-list-image gdlr-core-left"
                              style="max-width: 35px; margin-top: -2px;">
                         <img src="static/upload/logo01.png" alt=""
                              width="120"
                              height="120" title="logo01">
                        </span>
                        <div class="gdlr-core-icon-list-content-wrap">
                          <span class="gdlr-core-icon-list-content"
                                style="color: #1b1b1b; font-size: 19px; font-weight: 500; text-transform: none;">
                            传承安排
                          </span>
                          <ul>
                            <li>遵循委托人的意愿，给予所爱人财富</li>
                            <li>避免财富被挥霍</li>
                          </ul>
                        </div>
                      </li>
                      <li class="gdlr-core-skin-divider clearfix" style="margin-bottom: 17px;">
                        <span class="gdlr-core-icon-list-image gdlr-core-left"
                              style="max-width: 35px; margin-top: -2px;">
                         <img src="static/upload/logo02.png" alt=""
                              width="120"
                              height="120" title="logo01">
                        </span>
                        <div class="gdlr-core-icon-list-content-wrap">
                          <span class="gdlr-core-icon-list-content"
                                style="color: #1b1b1b; font-size: 19px; font-weight: 500; text-transform: none;">
                            资产安全
                          </span>
                          <ul>
                            <li>避免企业和个人债务风险</li>
                            <li>避免离婚财产风险</li>
                            <li>高度隐私</li>
                          </ul>
                        </div>
                      </li>
                      <li class="gdlr-core-skin-divider clearfix" style="margin-bottom: 17px;">
                        <span class="gdlr-core-icon-list-image gdlr-core-left"
                              style="max-width: 35px; margin-top: -2px;">
                         <img src="static/upload/logo03.png" alt=""
                              width="120"
                              height="120" title="logo01">
                        </span>
                        <div class="gdlr-core-icon-list-content-wrap">
                          <span class="gdlr-core-icon-list-content"
                                style="color: #1b1b1b; font-size: 19px; font-weight: 500; text-transform: none;">
                            税务规划
                          </span>
                          <ul>
                            <li>资产在低税或无税环境中增长和增值</li>
                            <li>合理进行各类税务规划及安排</li>
                          </ul>
                        </div>
                      </li>
                      <li class="gdlr-core-skin-divider clearfix" style="margin-bottom: 17px;">
                        <span class="gdlr-core-icon-list-image gdlr-core-left"
                              style="max-width: 35px; margin-top: -2px;">
                         <img src="static/upload/logo01.png" alt=""
                              width="120"
                              height="120" title="logo01">
                        </span>
                        <div class="gdlr-core-icon-list-content-wrap">
                          <span class="gdlr-core-icon-list-content"
                                style="color: #1b1b1b; font-size: 19px; font-weight: 500; text-transform: none;">
                            灵活持资
                          </span>
                          <ul>
                            <li>保单、房地产、股票证券和其他投资;现金甚至是个人物品例如:古董、艺术品和珠宝</li>
                          </ul>
                        </div>
                      </li>
                      <li class="gdlr-core-skin-divider clearfix" style="margin-bottom: 17px;">
                        <span class="gdlr-core-icon-list-image gdlr-core-left"
                              style="max-width: 35px; margin-top: -2px;">
                         <img src="static/upload/logo02.png" alt=""
                              width="120"
                              height="120" title="logo01">
                        </span>
                        <div class="gdlr-core-icon-list-content-wrap">
                          <span class="gdlr-core-icon-list-content"
                                style="color: #1b1b1b; font-size: 19px; font-weight: 500; text-transform: none;">
                            基业永续
                          </span>
                          <ul>
                            <li>避免分家</li>
                            <li>让家族企业治理更顺畅</li>
                          </ul>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br/>
    <br/>
    <br/>
    <br/>
    <!-- 分割线 -->
    <div class="gdlr-core-pbf-section">
      <div class="gdlr-core-pbf-section-container gdlr-core-container clearfix">
        <div class="gdlr-core-pbf-column gdlr-core-column-60 gdlr-core-column-first" id="gdlr-core-column-60251" style="z-index: 9;">
          <div class="gdlr-core-pbf-column-content-margin gdlr-core-js" style="margin: -45px 0px -65px 0px; padding: 0px 0px 0px 0px;">
            <div class="gdlr-core-pbf-background-wrap"></div>
            <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js">
              <div class="gdlr-core-pbf-element">
                <div class="gdlr-core-divider-item gdlr-core-divider-item-normal gdlr-core-item-pdlr gdlr-core-center-align" style="margin-bottom: 0px;">
                  <div class="gdlr-core-divider-container" style="max-width: 1px;"><div class="gdlr-core-divider-line gdlr-core-skin-divider" style="border-color: #d32525; border-width: 100px;"></div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'ServiceContent1'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/service/ServiceContent1.vue